var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#payment-notification[data-v-486069f5]{background-image:url(" + escape(require("../assets/img/backgrounds/background-after-login.jpg")) + ");background-repeat:no-repeat;max-width:inherit;max-height:100%;background-position:50%;background-size:cover}#payment-notification .payment-notification-container[data-v-486069f5]{margin-top:6em;height:100vh}#payment-notification .payment-notification-container h3[data-v-486069f5]{color:#3057b0}", ""]);

// exports
